import * as React from 'react';

import { redesignStaffManagement } from 'bundles/staff-management/src/utils/epic';

import StaffManagementCDS, { type PropsFromCaller as StaffManagementProps } from './cds/StaffManagement';

const InstitutionStaff = (props: StaffManagementProps) => (
  <StaffManagementCDS {...props} variant={redesignStaffManagement() ? 'CDSTable' : 'CDSLikeTable'} />
);

export default InstitutionStaff;
